import cn from "classnames"

import { Card, Flex, Link, Text } from "@/atoms"
import { StatusKai } from "@/molecules/StatusKai"
import { DataFlowButton } from "@/organisms/DataFlow"

import styles from "./CardIssueDescriptionKai.module.scss"

import type { CardIssueDescriptionKaiProps } from "./CardIssueDescriptionKai.types"

export const CardIssueDescriptionKai = (
  props: CardIssueDescriptionKaiProps
) => {
  const {
    line,
    description,
    url,
    isFalsePositive,
    dataflowAnalysis,
    inProgress,
    t
  } = props
  const showLink = !!(line && url)
  const showOnlyLine = !showLink && !!line
  const lineText = `${t("card.line")}: ${line}`

  return (
    <Card
      className={styles.card}
      title={
        <Flex align="center" gap={8} justify="space-between">
          {showLink && (
            <Link
              href={url}
              target="_blank"
              className={cn(styles.line, styles.link)}
            >
              {lineText}
            </Link>
          )}
          {showOnlyLine && <Text className={styles.line}>{lineText}</Text>}
          <StatusKai
            inProgress={inProgress}
            isFalsePositive={isFalsePositive}
            t={t}
          />
        </Flex>
      }
    >
      <Flex vertical gap={8}>
        {inProgress ? (
          <Text type="secondary" className={styles.text}>
            {t("card.analyzingHint")}
          </Text>
        ) : (
          <>
            {!!description && (
              <Text type="secondary" className={styles.text}>
                {description}
              </Text>
            )}
            {!!dataflowAnalysis && (
              <div>
                <DataFlowButton
                  className={styles.dataFlowButton}
                  onClick={() => {
                    if (dataflowAnalysis) props.setFlow(dataflowAnalysis)
                  }}
                />
              </div>
            )}
          </>
        )}
      </Flex>
    </Card>
  )
}
